import type { BotIdTags, FormVariant, LeadFormSurface } from "../types";

import { EventName } from "@homeinstead/shared";
import { trackClickEvent } from "./click-events";
import { getTrackedClickEventBody } from "./tracked-click";

export const ServiceLocationTrackedClickEvent = (
  PostalCode: number,
  OfficeLocation: number,
  formVariant: FormVariant,
) => ({
  ...getTrackedClickEventBody({
    element_name: "service_location_btn",
  }),
  form_variant: formVariant,
  IsCorporate: false,
  OfficeLocation,
  PostalCode,
});

// TODO: Update Array to accept only CareOption which has shape:
// export type CareOption = keyof CareSeekerLeadFormData["step3"];

// // For multiple selections (one or more)
// export type CareOptionSelection = [CareOption, ...CareOption[]];
export const ServiceTypeTrackedClickEvent = (
  selected_options: Array<string>,
  formVariant: FormVariant,
) => ({
  ...getTrackedClickEventBody({
    element_name: "service_types_next",
  }),
  form_variant: formVariant,
  IsCorporate: false,
  selected_options,
});

type FormSubmissionResult =
  | "success"
  | "duplicate"
  | "server-error"
  | "validation-error";

// TODO: Update types on selectedOptions and recipient to be more specific
export const ServiceLeadFormSubmitEvent = ({
  franchiseNumber,
  result,
  selectedOptions,
  recipient,
  formVariant,
  formVersionId,
  spamBlockReason,
  surface,
  tags,
  validationErrors,
}: {
  franchiseNumber?: string | undefined;
  result: FormSubmissionResult;
  selectedOptions?: string[] | undefined;
  recipient?: string | undefined;
  formVariant: FormVariant;
  formVersionId?: string;
  spamBlockReason?: string;
  surface?: LeadFormSurface;
  tags: BotIdTags;
  validationErrors?: Record<string, string>;
}) => ({
  event: EventName.SERVICE_LEAD_FORM_SUBMIT,
  form_id: "service-lead-form-ppc-restructure",
  form_submission_intent: "service",
  form_submission_result: result,
  form_variant: formVariant,
  ...(formVersionId ? { form_version_id: formVersionId } : {}),
  franchise_number: franchiseNumber,
  lang: "en",
  recipient,
  selected_options: selectedOptions,
  ...(spamBlockReason ? { spam_block_reason: spamBlockReason } : {}),
  ...(surface ? { surface } : {}),
  tags,
  ...(result === "validation-error"
    ? { validation_errors: validationErrors ?? {} }
    : {}),
});

export const EmployButtonTrackedClickEvent = () => {
  return trackClickEvent("employment_btn");
};

export const ServiceRecipientTrackedClickEvent = (
  recipient: string,
  formVariant: FormVariant,
) => ({
  recipient,
  ...getTrackedClickEventBody({
    element_name: "service_recipient",
  }),
  form_variant: formVariant,
  IsCorporate: false,
});

export const ServiceUrgencyTrackedClickEvent = (
  urgency: string,
  page_zone: string,
  formVariant: FormVariant,
) => ({
  element_name: "service_urgency",
  event: "tracked_click",
  form_variant: formVariant,
  IsCorporate: false,
  lang: "en",
  page_zone,
  urgency,
});
